import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 18,
			height: 18,
			rx: 2,
			ry: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("polyline", { points: "21 15 16 10 5 21" })
	]
});
export default SvgIconImage;
